import * as type from './type';


export const createQnaSuccess = (payload) => {

    return {
        type: type.CREATE_SUCCESS,
        payload,
    };
};

export const createQnaFaild = (payload) => {

    return {
        type: type.CREATE_FAILD,
        payload,
    };
};
